import React from "react";
import { Row, Col } from "antd";
import AddPhysicianModalWrapper from "../../modal/AddPhysicianModalWrapper";
import { CustomSecondaryButton, CustomButton } from "../physician_page/styled";
import { BsCheck2Circle } from "react-icons/bs";
import { useHistory } from "react-router-dom";
import { ModalWrapper } from "../admin/videos/styled";


const VideoCompleteModel = ({ isOpen, setOpen }) => {
  return (
    <>
      <ModalWrapper
      centered
      open = {isOpen}
      onCancel = {() => setOpen(false)}
      width={500}
      footer={null}
      className="custom-subscription-modal"
>
        <Row className="d-flex justify-content-center mb-10">
          <div
            className="d-flex delete-modal-icon"
            style={{ backgroundColor: "#dcfce7" }}
          >
            <BsCheck2Circle style={{ fontSize: "40px", color: "#16a34a" }} />
          </div>
        </Row>
        <Row className="d-flex justify-content-center mb-5">
          <span className="font-24 font-semibold custom-primary-text">
           Thanks for watching this video
          </span>
        </Row>
{/* 
        <Row className="d-flex justify-content-center mb-15">
          <Col className="font-17 font-medium custom-secondary-text">
            Thank you for subscribing to Meducate.ai. Your payment has been
            processed successfully.
          </Col>
        </Row>

        <Row className="d-flex justify-content-center mb-15">
          <Col className="font-17 font-medium custom-secondary-text">
            You will receive a confirmation email shortly with your subscription
            details.
          </Col>
        </Row> */}

        {/* <Row
          className="w-100 d-flex justify-content-center font-medium font-15 mb-50"
          style={{
            backgroundColor: "#fef9c3",
            padding: "12px",
            borderRadius: "7px",
            color: "#854d0e",
          }}
        >
          <Col>
            <strong>Development Mode:</strong> Using test Stripe keys. In
            production, replace the test variables in app/pricing/actions.ts
            with your actual Stripe API keys.
          </Col>
        </Row> */}
{/* 
        <Row>
          <Col span={24} className="d-flex justify-content-center gap-12">
            <CustomButton
              onClick={() => {
                setOpen(false);

              }}
              style={{ padding: "20px 50px" }}
            >
              OK
            </CustomButton>
          </Col>
        </Row> */}
      </ModalWrapper>
    </>
  );
};

export default VideoCompleteModel;
